import { Link, useNavigate } from "react-router-dom";
import { ShoppingCart, User, Menu, X, ShieldCheck, LogOut } from "lucide-react";
import { useState } from "react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

export const Navbar = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const links = [
    { to: "/shop", label: "Shop All" },
    { to: "/shop?category=shirts", label: "Shirts" },
    { to: "/shop?category=stickers", label: "Stickers" },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#050505]/70 border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-heading text-2xl font-900 tracking-tight uppercase flex items-center gap-2">
          <span className="text-[#E63946]">CHRIST</span>
          <span className="text-white">RACING</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.label} to={l.to} data-testid={`nav-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
              className="text-sm font-semibold uppercase tracking-[0.15em] text-[#A1A1AA] hover:text-white transition-colors">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-4">
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin" title="Admin" className="text-[#C5A059] hover:text-white transition-colors">
              <ShieldCheck size={20} />
            </Link>
          )}
          {user ? (
            <button onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout" title="Logout" className="text-[#A1A1AA] hover:text-white transition-colors">
              <LogOut size={20} />
            </button>
          ) : (
            <Link to="/login" data-testid="nav-account" title="Account" className="text-[#A1A1AA] hover:text-white transition-colors">
              <User size={20} />
            </Link>
          )}
          <Link to="/cart" data-testid="nav-cart" className="relative text-white hover:text-[#E63946] transition-colors">
            <ShoppingCart size={22} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-2 -right-2 bg-[#E63946] text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full">
                {count}
              </span>
            )}
          </Link>
          <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#050505] px-5 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setOpen(false)}
              className="text-sm font-semibold uppercase tracking-[0.15em] text-[#A1A1AA] hover:text-white">
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
